import superagent from 'superagent';
import webservice from './webservice';
import getCookie from './getCookie';

export default async function GetPaymentIrelandPay({ jsonBody }) {
  let url = `${webservice}/GetPaymentIrelandPay`;

  let response = {};

  await superagent
    .get(url)
    .auth(getCookie('TMBcartToken'), { type: 'bearer' })
    .set('Content-Type', 'application/json')
    .query(jsonBody)
    .then((res) => {
      response = res.body;
    })
    .catch((err) => {
      console.log(err);
      const resp = {
        ...jsonBody,
        error: err,
        tipoMensaje: 'error',
        mensaje: 'Error',
      };
      response = resp;
    });

  return response;
}
